import MovieListing from "../components/movies/movie-listing/MovieListing";

const Movies = () => {
  return (
    <>
      Movies
      <MovieListing />
    </>
  );
};

export default Movies;
